import {
  acquireAccessToken,
  getFieldName,
  getFieldText,
  getFieldUTC,
  jscd,
} from "./../../scripts/helperScripts";
import { msalInstance } from "../../index";
import { toast } from "react-toastify";

const reactApiUrl = "https://eurekaapi.azurewebsites.net";
const zetoApiUrl = "https://safyzetoapi.azurewebsites.net";
const orgUrl = process.env.REACT_APP_ORG;
const orgApi = orgUrl.replace("https://", "").replace(".safy.org", "");
let soarOrg =
  process.env.REACT_APP_ENVIRONMENT === "Production"
    ? "SOARLive"
    : "SOARD365Base";

const logOrg =
  process.env.REACT_APP_ENVIRONMENT === "Production"
    ? "ReactLive"
    : process.env.REACT_APP_ENVIRONMENT === "DevOps Test"
    ? "ReactTest"
    : process.env.REACT_APP_ENVIRONMENT === "Development"
    ? "ReactDev"
    : "ReactIdk";

const databaseOrg =
  process.env.REACT_APP_ENVIRONMENT === "Production" ? "ReactLive" : "ReactDev";

const eurekaEnvironment =
  process.env.REACT_APP_ENVIRONMENT === "Production" ? "Live" : "Test";

export async function soarFetch(fetchXml) {
  const endpoint = "Fetch?fetchXml=" + fetchXml;
  return await soarApi(endpoint, "safy\\usiservices");
}

async function soarApi(endpoint, user) {
  // try {
  //   // var accessToken = await msalInstance.acquireTokenSilent({
  //   //   scopes: config.scopes,
  //   // });
  //   // if (accessToken) {
  //   const url = `${apiUrl}/${endpoint}&userName=${user}&org=${orgUrl}`;
  //   var data = await fetch(url)
  //     .then(function (response) {
  //       return response.json();
  //     })
  //     .then(function (result) {
  //       if (result.resultset) {
  //         return result.resultset.result;
  //       }
  //     });
  //   return data;
  //   // }
  //   //return "unknown error";
  // } catch (err) {
  //   return "error:" + err;
  // }
}

export async function soarUpdateApi(endpoint, obj, count, logData = undefined) {
  //soarUpdateApi is swtiched to a POST method to allow for larger payloads
  //and resource moved to Eureka API
  const url = `https://eurekaapi.azurewebsites.net/${endpoint}`;

  var accessToken = await msalInstance.acquireTokenSilent({
    scopes: ["https://eurekaapi.azurewebsites.net/access_as_user"],
  });

  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${accessToken.accessToken}`);

  var requestOptions = {
    method: "POST",
    body: obj,
    headers: myHeaders,
  };
  return new Promise(async (resolve, reject) => {
    const response = await fetch(url, requestOptions);

    if (!response) {
      reject("No response");
      return;
    }

    if (response.ok) {
      const result = await response.json();

      if (!result) {
        reject("No result");
        return;
      }

      resolve(JSON.parse(result));
      return;
    }

    const responseStatus = response.status;
    const responseStatusText = response.statusText;

    return response.json().then((result) => {
      const responseMessage =
        result !== undefined && result.Message !== undefined
          ? result.Message.toLowerCase()
          : "";

      if (
        responseMessage.includes("timeout") ||
        responseMessage.includes(
          "metadata contains a reference that cannot be resolved"
        ) ||
        responseMessage.includes("there was no endpoint listening")
      ) {
        if (count <= 5) {
          soarUpdateApi(endpoint, obj, count + 1, logData)
            .then(resolve)
            .catch(reject);
        } else {
          reject(`${responseMessage.substring(0, 47)}...`);
        }
      } else {
        if (logData) {
          const errorLogData = {
            ...logData,
            FullError: JSON.stringify({
              ...result,
              Status: responseStatus,
              StatusText: responseStatusText,
            }),
            Org: logOrg,
            ResponseCode: responseStatus,
            ResponseMessage: result.Message,
            ExceptionType: result.ClassName || responseStatusText,
            Application: "React Portal",
          };

          writeErrorLog(errorLogData);
        }

        reject(`${responseMessage.substring(0, 47)}...`);
      }
    });
  });
}

export async function CCPLUpdate(url, count, logData = undefined) {
  return new Promise((resolve, reject) => {
    fetch(url)
      .then((response) => {
        if (response) {
          if (response.ok) {
            return response.json();
          } else {
            const responseStatus = response.status;
            const responseStatusText = response.statusText;

            return response.json().then((result) => {
              const responseMessage =
                result !== undefined && result.Message !== undefined
                  ? result.Message.toLowerCase()
                  : "";

              if (
                responseMessage.includes("timeout") ||
                responseMessage.includes(
                  "metadata contains a reference that cannot be resolved"
                ) ||
                responseMessage.includes("there was no endpoint listening")
              ) {
                if (count <= 5) {
                  CCPLUpdate(url, count + 1)
                    .then(resolve)
                    .catch(reject);
                } else {
                  throw result;
                }
              } else {
                if (logData) {
                  const errorLogData = {
                    ...logData,
                    FullError: JSON.stringify({
                      ...result,
                      Status: responseStatus,
                      StatusText: responseStatusText,
                    }),
                    Org: logOrg,
                    ResponseCode: responseStatus,
                    ResponseMessage: result.Message,
                    ExceptionType: result.ClassName || responseStatusText,
                    Application: "React Portal",
                  };

                  writeErrorLog(errorLogData);
                }

                reject(`${responseMessage.substring(0, 47)}...`);
              }
            });
          }
        }
      })
      .then((result) => {
        if (result) {
          resolve(result);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function soarPostApi(endpoint, user, obj) {
  // try {
  //   const url = `${apiUrl}/${endpoint}&userName=${user}&org=${orgUrl}`;
  //   var myHeaders = new Headers();
  //   myHeaders.append("Content-Type", "application/json");
  //   var requestOptions = {
  //     method: "POST",
  //     body: JSON.stringify(obj),
  //     headers: myHeaders,
  //   };
  //   //alert(url);
  //   var data = await fetch(url, requestOptions)
  //     .then(function (response) {
  //       return response.json();
  //     })
  //     .then(function (result) {
  //       return result;
  //     });
  //   return data;
  // } catch (err) {
  //   return "error:" + err;
  // }
}

async function callProxyApi(uri) {
  try {
    return eurekaGet(
      `https://eurekaapi.azurewebsites.net/api/Proxy?uri=${uri}`
    );
  } catch (err) {
    return "error: " + err;
  }
}

// async function Opeeka(endpoint, token, body, requestOptions) {
//   try {
//     var myHeaders = new Headers();
//     myHeaders.append("Content-Type", "application/json");
//     myHeaders.append("Authorization", "Bearer " + token.access_token);

//     var data = await fetch(endpoint, requestOptions)
//       .then(function (response) {
//         return response.json();
//       })
//       .then(function (result) {
//         return result;
//       });
//     return data;
//   } catch (err) {
//     return "error:" + err;
//   }
// }

export async function getClientPhoto(contactId) {
  // try {
  //   const url = `${apiUrl}/ClientImage?org=${orgUrl}&clientID=${contactId}`;
  //   var data = await fetch(url)
  //     .then((response) => response.blob())
  //     .then((blob) => {
  //       return {
  //         src: blob.size > 0 ? URL.createObjectURL(blob) : null,
  //       };
  //     });
  //   return data;
  // } catch (err) {
  //   return "error:" + err;
  // }

  try {
    const image = await eurekaGet(
      `https://eurekaapi.azurewebsites.net/Get/Client/Image/${soarOrg}/${contactId}`
    );

    const entityImage = JSON.parse(image).resultset.result[0].EntityImage;
    const result = {};
    if (entityImage) {
      result.src = `data:Image/png;base64,${entityImage}`;
    }
    return result;
  } catch (err) {
    return "error:" + err;
  }
}

export async function AzureDB(query, param) {
  // try {
  //   const url = `${apiUrl}/SAFY?query=${query}&param=${param}`;
  //   var data = await fetch(url)
  //     .then(function (response) {
  //       return response.json();
  //     })
  //     .then(function (result) {
  //       return result;
  //     });
  //   return data;
  // } catch (err) {
  //   return "error";
  // }
}

function ArrayCheck(data) {
  return data !== undefined && !Array.isArray(data) ? [data] : data;
}

export async function getContact(contactId, signal) {
  try {
    const contact = await eurekaGet(
      `https://eurekaapi.azurewebsites.net/Get/Contact/${soarOrg}/${contactId}`,
      signal
    );

    return ArrayCheck(JSON.parse(contact).resultset.result);
  } catch (err) {
    if (err.name !== "AbortError") {
      return err;
    }
  }
}

export async function searchContact(searchQuery, businessUnit, signal) {
  const contact = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/Search/Contact/${soarOrg}/${
      businessUnit !== "ccplive"
        ? `${businessUnit}/${searchQuery}`
        : searchQuery
    }`,
    signal
  );

  if (!signal?.aborted) {
    return ArrayCheck(JSON.parse(contact).resultset.result).sort((a, b) => {
      const aName = a.fullname;
      const bName = b.fullname;
      if (aName > bName) return 1;
      if (aName < bName) return -1;
      return 0;
    });
  }
}

export async function getMyCaseload(userID) {
  const userName = userID.replace("@safy.org", "");
  const caseload = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/MyCaseLoad/${soarOrg}/${userName}`
  );
  return ArrayCheck(JSON.parse(caseload).resultset.result);
}

export async function getCaseloadCarePlans(userID) {
  const caseload = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/CaseLoad/CarePlans/${soarOrg}/${userID}`
  );
  return ArrayCheck(JSON.parse(caseload).resultset.result);
}

export async function getTeamCaseload(divisions) {
  const joinedDivisions = { Divisions: `'${divisions.join("','")}'` };

  const caseload = await eurekaPost(
    `https://eurekaapi.azurewebsites.net/Post/TeamCaseLoad/${soarOrg}`,
    joinedDivisions
  );

  return ArrayCheck(JSON.parse(caseload).resultset.result);
}

export async function getTeamClients(divisions) {
  const joinedDivisions = { Divisions: `'${divisions.join("','")}'` };

  const teamClients = await eurekaPost(
    `https://eurekaapi.azurewebsites.net/Post/TeamClients/${soarOrg}`,
    joinedDivisions
  );

  const result = ArrayCheck(JSON.parse(teamClients).resultset.result);

  result.sort((a, b) => {
    if (a.fullname.toUpperCase() > b.fullname.toUpperCase()) return 1;
    if (a.fullname.toUpperCase() < b.fullname.toUpperCase()) return -1;
    return 0;
  });

  return result;
}

export async function getCompliancyProgramUnitCaseload(programUnit) {
  const caseload = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/Compliancy/Clients/${soarOrg}/${programUnit}`
  );
  return caseload.resultset;
}

export async function getCompliancyMyCaseload(user) {
  const caseload = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/Compliancy/MyCaseLoad/${soarOrg}/${user}`
  );
  return caseload.resultset;
}

export async function getAllTeamClients(divisions) {
  const joinedDivisions = { Divisions: `'${divisions.join("','")}'` };

  const teamClients = await eurekaPost(
    `https://eurekaapi.azurewebsites.net/Post/TeamClients2/${soarOrg}`,
    joinedDivisions
  );

  const result = ArrayCheck(JSON.parse(teamClients).resultset.result);

  result.sort((a, b) => {
    if (a.fullname.toUpperCase() > b.fullname.toUpperCase()) return 1;
    if (a.fullname.toUpperCase() < b.fullname.toUpperCase()) return -1;
    return 0;
  });

  return result;
}

export async function getFastTimeEntryClients(divisions, signal) {
  try {
    const joinedDivisions = { Divisions: `'${divisions.join("','")}'` };

    const teamClients = await eurekaPost(
      `https://eurekaapi.azurewebsites.net/Post/FastTimeEntry/Clients/List/${soarOrg}`,
      joinedDivisions,
      signal
    );

    const result = ArrayCheck(JSON.parse(teamClients).resultset.result);

    result.sort((a, b) => {
      if (a.fullname.toUpperCase() > b.fullname.toUpperCase()) return 1;
      if (a.fullname.toUpperCase() < b.fullname.toUpperCase()) return -1;
      return 0;
    });

    return result;
  } catch (err) {
    if (err.name !== "AbortError") {
      return err;
    }
  }
}

export async function postFastTimeEntry(entry, signal) {
  return await zetoPost(
    `${reactApiUrl}/Post/FastTimeEntry/Eureka`,
    { data: entry },
    signal
  );
}

export async function getTeamClientsByProgramName(divisions, programName) {
  const joinedDivisions = {
    Divisions: `'${divisions.join("','")}'`,
  };

  const teamClients = await eurekaPost(
    `https://eurekaapi.azurewebsites.net/Post/Divisions/Program/Clients/List/${soarOrg}/${programName}`,
    joinedDivisions
  );

  const result = ArrayCheck(JSON.parse(teamClients).resultset.result);

  result.sort((a, b) => {
    const aName = getFieldName(a.ccx_patient);
    const bName = getFieldName(b.ccx_patient);
    return aName.localeCompare(bName, undefined, { sensitivity: "accent" });
  });

  return result;
}

export async function getTeamCarePlans(divisions) {
  const joinedDivisions = { Divisions: `'${divisions.join("','")}'` };

  const teamCarePlans = await eurekaPost(
    `https://eurekaapi.azurewebsites.net/Post/Team/CarePlans/${soarOrg}`,
    joinedDivisions
  );

  return ArrayCheck(JSON.parse(teamCarePlans).resultset.result);
}

export async function getProgramUnits(businessUnit, signal) {
  try {
    const programUnits = await eurekaGet(
      `https://eurekaapi.azurewebsites.net/Get/ProgramUnits/${soarOrg}/${businessUnit}`,
      signal
    );

    return ArrayCheck(JSON.parse(programUnits).resultset.result);
  } catch (err) {
    return "error: " + err;
  }
}

export async function getProgramUnitsConfig(connection) {
  try {
    const response = await eurekaGet(
      `https://eurekaapi.azurewebsites.net/Get/Unit/Configurations/${connection}`
    );

    if (response) {
      const responseJSON = JSON.parse(response);

      if (responseJSON.resultset.result !== undefined) {
        return responseJSON.resultset.result;
      }
    }
  } catch (err) {
    return "error: " + err;
  }
}

//NEW ZETO Version of call above. Need to refactor existing references at some point
export async function programUnitConfigs(body, signal) {
  const response = await zPost(
    `${zetoApiUrl}/soar/program/units`,
    body,
    signal
  );

  return response;
}

export async function getDivisionsProgramUnits(divisions) {
  const joinedDivisions = { Divisions: `'${divisions.join("','")}'` };

  const programUnits = await eurekaPost(
    `https://eurekaapi.azurewebsites.net/Post/ProgramUnits/${soarOrg}`,
    joinedDivisions
  );

  return ArrayCheck(JSON.parse(programUnits).resultset.result);
}

export async function getUser(userName) {
  const userResults = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/User/${soarOrg}/${userName}`
  );

  return ArrayCheck(JSON.parse(userResults).resultset.result);
}

export async function getUsers() {
  const users = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/Users/${soarOrg}`
  );

  return ArrayCheck(JSON.parse(users).resultset.result).sort((a, b) => {
    if (a.fullname.toUpperCase() > b.fullname.toUpperCase()) return 1;
    if (a.fullname.toUpperCase() < b.fullname.toUpperCase()) return -1;
    return 0;
  });
}

export async function getADUsers() {
  const users = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/System/Get/ADUsers`
  );

  return ArrayCheck(users.data).sort((a, b) => {
    if (a.fullname.toUpperCase() > b.fullname.toUpperCase()) return 1;
    if (a.fullname.toUpperCase() < b.fullname.toUpperCase()) return -1;
    return 0;
  });
}

export async function getContactMetadata() {
  const types = await soarUpdateApi(
    `Metadata?type=Entity&entityName=contact&attributeName=null`,
    "safy\\usiservices"
  );
  return types;
}

export async function getClientCarePlans(contactId) {
  const carePlans = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/Client/CarePlans/${soarOrg}/${contactId}`
  );

  return ArrayCheck(JSON.parse(carePlans).resultset.result).sort((a, b) => {
    const aDate = new Date(getFieldText(a.createdon));
    const bDate = new Date(getFieldText(b.createdon));
    if (aDate < bDate) return 1;
    if (aDate > bDate) return -1;
    return 0;
  });
}

export async function getClientCarePlansPromise(contactId) {
  return new Promise((resolve, reject) => {
    try {
      eurekaGet(
        `https://eurekaapi.azurewebsites.net/Get/Client/CarePlans/${soarOrg}/${contactId}`
      )
        .then((carePlans) => {
          const carePlansJSON = JSON.parse(carePlans);
          if (
            carePlansJSON &&
            carePlansJSON.resultset &&
            carePlansJSON.resultset.result
          ) {
            const sortedCarePlans = ArrayCheck(
              carePlansJSON.resultset.result
            ).sort((a, b) => {
              const aDate = new Date(getFieldText(a.createdon));
              const bDate = new Date(getFieldText(b.createdon));
              if (aDate < bDate) return 1;
              if (aDate > bDate) return -1;
              return 0;
            });
            resolve(sortedCarePlans);
          } else resolve([]);
        })
        .catch(reject);
    } catch (error) {
      reject(error);
    }
  });
}

export async function getCarePlanDetails(carePlanId) {
  return new Promise((resolve, reject) => {
    try {
      eurekaGet(
        `https://eurekaapi.azurewebsites.net/Reports/Careplan2/${soarOrg}/${carePlanId}`
      )
        .then((carePlans) => {
          const carePlansJSON = JSON.parse(carePlans);

          if (
            carePlansJSON &&
            carePlansJSON.Reports &&
            carePlansJSON.Reports.CarePlan
          )
            resolve(carePlansJSON.Reports.CarePlan[0]);
          else resolve();
        })
        .catch(reject);
    } catch (error) {
      reject(error);
    }
  });
}

export async function getDiagnosisDetails(clientProgramID, signal) {
  const dxDetailResults = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/Client/Program/DxDetails/${soarOrg}/${clientProgramID}`,
    signal
  );

  if (!signal?.aborted) {
    return ArrayCheck(JSON.parse(dxDetailResults).resultset.result);
  }
}

export async function getClientDiagnosisDetails(contactId, signal) {
  const dxDetails = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/Client/DxDetails/${soarOrg}/${contactId}`,
    signal
  );

  if (!signal?.aborted) {
    const result = ArrayCheck(JSON.parse(dxDetails).resultset.result);

    result.sort((a, b) => {
      const aName = getFieldName(a.ccx_clientdiagnosis);
      const bName = getFieldName(b.ccx_clientdiagnosis);
      if (aName > bName) return 1;
      if (aName < bName) return -1;
      return 0;
    });

    return result;
  }
}

export async function searchICD10(search) {
  const icd10Results = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/Search/ICD10/${soarOrg}/${search.replace(
      ".",
      "(period)"
    )}`
  );

  return ArrayCheck(JSON.parse(icd10Results).resultset.result).filter(
    (icd10) => icd10.ccx_expdate === undefined
  );
}

export async function searchDSM5(search) {
  const dsm5Results = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/Search/DSM5/${soarOrg}/${search}`
  );

  return ArrayCheck(JSON.parse(dsm5Results).resultset.result).filter(
    (dsm5) => dsm5.ccx_expdate === undefined
  );
}

export async function getClientPayors(contactId) {
  const payors = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/Client/Payors/${soarOrg}/${contactId}`
  );

  return ArrayCheck(JSON.parse(payors).resultset.result);
}

export async function getCareTeam(contactId) {
  const careTeam = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/CareTeam/${soarOrg}/${contactId}`
  );

  return ArrayCheck(JSON.parse(careTeam).resultset.result);
}

export async function getClientPrograms(contactId) {
  const clientPrograms = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/ClientProgram/${soarOrg}/${contactId}`
  );

  return ArrayCheck(JSON.parse(clientPrograms).resultset.result);
}

export async function getIncidents(contactId) {
  const incidents = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/Client/Incidents/${soarOrg}/${contactId}`
  );

  return ArrayCheck(JSON.parse(incidents).resultset.result);
}

export async function getSoarCorrespondence(recordId) {
  const correspondence = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/Soar/Correspondence/${soarOrg}/${recordId}`
  );

  return ArrayCheck(JSON.parse(correspondence).resultset.result).sort(
    (a, b) => {
      const aDate = new Date(getFieldText(a.sor_dateandstarttime));
      const bDate = new Date(getFieldText(b.sor_dateandstarttime));
      if (aDate > bDate) return -1;
      if (aDate < bDate) return 1;
      return 0;
    }
  );
}

export async function getDocumentsLocation(contactId) {
  const location = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/DocumentsLocation/${soarOrg}/${contactId}`
  );

  return ArrayCheck(JSON.parse(location).resultset.result);
}

export async function getAddresses(contactId) {
  const addresses = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/Client/Addresses/${soarOrg}/${contactId}`
  );

  return ArrayCheck(JSON.parse(addresses).resultset.result);
}

export async function getFosterBeds(contactId, signal) {
  const response = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/Client/FosterBeds/${soarOrg}/${contactId}`,
    signal
  );

  if (!signal?.aborted && response) {
    const result = JSON.parse(response);

    if (result.resultset?.result) {
      return ArrayCheck(result.resultset.result);
    }
  }

  return [];
}

export async function getCareModalities(contactId, signal) {
  const careModalities = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/Client/CareModalities/${soarOrg}/${contactId}`,
    signal
  );

  if (!signal?.aborted) {
    return ArrayCheck(JSON.parse(careModalities).resultset.result);
  }
}

export async function getAllergies(contactId) {
  const allergies = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/Client/Allergies/${soarOrg}/${contactId}`
  );

  return ArrayCheck(JSON.parse(allergies).resultset.result);
}

export async function getMedications(contactId, signal) {
  const medications = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/Client/Medications/${soarOrg}/${contactId}`,
    signal
  );

  if (!signal?.aborted) {
    return ArrayCheck(JSON.parse(medications).resultset.result);
  }
}

export async function getClientRates(contactId) {
  const rates = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/Client/Rates/${soarOrg}/${contactId}`
  );

  return ArrayCheck(JSON.parse(rates).resultset.result).sort((a, b) => {
    const aDate = new Date(getFieldUTC(a.sor_effdate));
    const bDate = new Date(getFieldUTC(b.sor_effdate));
    if (aDate > bDate) return -1;
    if (aDate < bDate) return 1;

    const aCreatedDate = new Date(getFieldUTC(a.createdon));
    const bCreatedDate = new Date(getFieldUTC(b.createdon));
    if (aCreatedDate > bCreatedDate) return -1;
    if (aCreatedDate < bCreatedDate) return 1;

    return 0;
  });
}

export async function getCSSRS(contactId) {
  const cssrsResults = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/Client/CSSRS/${soarOrg}/${contactId}`
  );

  return ArrayCheck(JSON.parse(cssrsResults).resultset.result);
}

export async function getPatientForms(contactId) {
  const patientFormResults = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/Client/PatientForms/List/${soarOrg}/${contactId}`
  );

  return ArrayCheck(JSON.parse(patientFormResults).resultset.result);
}

export async function getDivisionFosterHomes(divisions) {
  const joinedDivisions = { Divisions: `'${divisions.join("','")}'` };

  const fosterHomes = await eurekaPost(
    `https://eurekaapi.azurewebsites.net/Post/DivisionFosterHomeAddresses/${soarOrg}`,
    joinedDivisions
  );

  return ArrayCheck(JSON.parse(fosterHomes).resultset.result);
}

export async function getFosterHomeAddressesByID(fostehomeID) {
  const addresses = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/FosterHomeAddress/${soarOrg}/${fostehomeID}`
  );

  return ArrayCheck(JSON.parse(addresses).resultset.result);
}

export async function getDivisionActiveFosterHomes(divisions) {
  const joinedDivisions = { Divisions: `'${divisions.join("','")}'` };

  const fosterHomeAddresses = await eurekaPost(
    `https://eurekaapi.azurewebsites.net/Post/DivisionActiveFosterHomes/${soarOrg}`,
    joinedDivisions
  );

  return ArrayCheck(JSON.parse(fosterHomeAddresses).resultset.result);
}

export async function getSOARFosterHomeInfo(fosterHomeId, signal) {
  return eurekaGet(
    `${reactApiUrl}/Get/FosterHome/BasicInfo/${soarOrg}/${fosterHomeId}`,
    signal
  );
}

export async function getRecordedServices(contactId) {
  const recordedServices = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/Client/RecordedServices/${soarOrg}/${contactId}`
  );

  return ArrayCheck(JSON.parse(recordedServices).resultset.result);
}

export async function getRecordedServicesPromise(contactId, signal) {
  return new Promise((resolve, reject) => {
    try {
      eurekaGet(
        `https://eurekaapi.azurewebsites.net/Get/Client/RecordedServices/${soarOrg}/${contactId}`,
        signal
      )
        .then((recordedServices) => {
          if (!signal?.aborted) {
            const recordedServicesJSON = JSON.parse(recordedServices);

            if (
              recordedServicesJSON &&
              recordedServicesJSON.resultset &&
              recordedServicesJSON.resultset.result
            ) {
              resolve(ArrayCheck(recordedServicesJSON.resultset.result));
            } else resolve([]);
          } else resolve([]);
        })
        .catch(reject);
    } catch (error) {
      reject(error);
    }
  });
}

export async function getProgressNotes(contactId) {
  const progressNotes = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/Client/ProgressNotes/${soarOrg}/${contactId}`
  );

  return ArrayCheck(JSON.parse(progressNotes).resultset.result);
}

export async function getEncounters(contactId) {
  const encounters = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/Client/Encounters/${soarOrg}/${contactId}`
  );

  return ArrayCheck(JSON.parse(encounters).resultset.result);
}

export async function getSignedEncounters(contactId, signal) {
  return new Promise((resolve, reject) => {
    try {
      eurekaGet(
        `https://eurekaapi.azurewebsites.net/Get/Client/Encounters/Signed/${soarOrg}/${contactId}`,
        signal
      )
        .then((encounters) => {
          if (!signal?.aborted) {
            const encountersJSON = JSON.parse(encounters);

            if (
              encountersJSON &&
              encountersJSON.resultset &&
              encountersJSON.resultset.result
            ) {
              resolve(ArrayCheck(encountersJSON.resultset.result));
            } else resolve([]);
          }
        })
        .catch(reject);
    } catch (error) {
      reject(error);
    }
  });
}

export async function getFosterHomeBeds(fosterHomeID) {
  const bedResults = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/FosterHome/Beds/${soarOrg}/${fosterHomeID}`
  );

  return ArrayCheck(JSON.parse(bedResults).resultset.result);
}

export async function getFosterHomeRates(fosterHomeID) {
  const fosterHomeRates = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/FosterHome/Rates/${soarOrg}/${fosterHomeID}`
  );

  return ArrayCheck(JSON.parse(fosterHomeRates).resultset.result);
}

export async function getAddressTypes() {
  const types = await soarUpdateApi(
    `Metadata?type=Attribute&entityName=ccx_contactaddress&attributeName=ccx_addresstype`,
    "safy\\usiservices"
  );
  return types;
}

export async function getFosterHomeMembers(fosterHomeID) {
  const fosterHomeMembers = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/FosterHome/Members/${soarOrg}/${fosterHomeID}`
  );

  return ArrayCheck(JSON.parse(fosterHomeMembers).resultset.result);
}

export async function getFPInvestigations(fosterHomeID) {
  const investigations = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/FosterHome/Investigation/${soarOrg}/${fosterHomeID}`
  );

  return ArrayCheck(JSON.parse(investigations).resultset.result);
}

export async function getFosterHomeNotes(fosterHomeID) {
  const fosterHomeNotes = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/FosterHome/Notes/${soarOrg}/${fosterHomeID}`
  );

  return ArrayCheck(JSON.parse(fosterHomeNotes).resultset.result);
}

export async function getStates(signal) {
  const states = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/States/${soarOrg}`,
    signal
  );

  if (!signal?.aborted) {
    return ArrayCheck(JSON.parse(states).resultset.result);
  }
}

export async function getProgramModalities(contactId, effectiveDate) {
  const modalities = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/Program/Modalities/${soarOrg}/${contactId}/${effectiveDate}`
  );

  return ArrayCheck(JSON.parse(modalities).resultset.result);
}

export async function getPayorAddresses(effectiveDate, businessUnitName) {
  const addresses = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/Payor/Addresses/${soarOrg}/${businessUnitName}/${effectiveDate}`
  );

  return ArrayCheck(JSON.parse(addresses).resultset.result);
}

export async function getPermanencyStatuses(contactId) {
  const permanencyStatuses = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/Client/PermanencyStatuses/${soarOrg}/${contactId}`
  );

  return ArrayCheck(JSON.parse(permanencyStatuses).resultset.result);
}

export async function getBedAppointments(contactId) {
  const bedAppointments = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/Client/BedAppointments/${soarOrg}/${contactId}`
  );

  return ArrayCheck(JSON.parse(bedAppointments).resultset.result);
}

export async function getClientCompanies(contactId, businessUnitName, signal) {
  const clientCompanies = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/ClientCompanies/${soarOrg}/${businessUnitName}/${contactId}`,
    signal
  );

  if (!signal?.aborted) {
    return ArrayCheck(JSON.parse(clientCompanies).resultset.result);
  }
}

export async function getUserProgramUnits(businessUnitName) {
  const programUnits = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/ProgramUnits/${soarOrg}/${businessUnitName}`
  );

  return ArrayCheck(JSON.parse(programUnits).resultset.result);
}

export async function getProgramServiceItemGroup(
  programUnitId,
  businessUnitName
) {
  const serviceItemGroups = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/ProgramServiceItemGroup/${soarOrg}/${businessUnitName}/${programUnitId}`
  );

  return ArrayCheck(JSON.parse(serviceItemGroups).resultset.result);
}

export async function getProgramServiceItems(
  serviceItemGroup,
  businessUnitName
) {
  const serviceItems = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/ProgramServiceItems/${soarOrg}/${businessUnitName}/${serviceItemGroup}`
  );

  return ArrayCheck(JSON.parse(serviceItems).resultset.result);
}

export async function getProgramServiceStatuses(businessUnitName) {
  const serviceStatuses = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/ProgramServiceStatuses/${soarOrg}`
  );

  return ArrayCheck(JSON.parse(serviceStatuses).resultset.result);
}

export async function getServiceItemStatuses(serviceItem) {
  const serviceStatuses = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/ServiceItemStatuses/${soarOrg}/${serviceItem}`
  );

  return ArrayCheck(JSON.parse(serviceStatuses).resultset.result);
}

export async function getAvailableFosterBeds(
  admissionDate,
  clientProgramId,
  businessUnitName
) {
  const fosterBeds = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/AvailableFosterBeds/${soarOrg}/${businessUnitName}/${clientProgramId}/${admissionDate}`
  );

  return ArrayCheck(JSON.parse(fosterBeds).resultset.result);
}

export async function getClientIdentifiers(contactId, signal) {
  const clientIdentifiers = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/Client/Identifiers/${soarOrg}/${contactId}`,
    signal
  );

  if (!signal?.aborted) {
    return ArrayCheck(JSON.parse(clientIdentifiers).resultset.result);
  }
}

export async function getClientProgramIdentifiers(
  clientProgramId,
  businessUnitName
) {
  const clientProgramIdentifiers = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/ProgramUnitIdentifier/${soarOrg}/${businessUnitName}/${clientProgramId}`
  );

  return ArrayCheck(JSON.parse(clientProgramIdentifiers).resultset.result);
}

export async function getFacilityAddresses(
  businessUnitName,
  expireOffsetYears = 3
) {
  const facilityAddresses = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/FacilityAddress/${soarOrg}/${businessUnitName}/${expireOffsetYears}`
  );

  return ArrayCheck(JSON.parse(facilityAddresses).resultset.result);
}

export async function getReferringAgencies(businessUnitName) {
  const referringAgencies = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/ReferringAgencies/${soarOrg}/${businessUnitName}`
  );

  return ArrayCheck(JSON.parse(referringAgencies).resultset.result);
}

export async function getProgramUnitBeds(programUnitId, businessUnitName) {
  const Beds = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/ProgramUnitBeds/${soarOrg}/${businessUnitName}/${programUnitId}`
  );

  return ArrayCheck(JSON.parse(Beds).resultset.result);
}

export async function getBedsWithBedAppointments(
  programUnitId,
  admissionDate,
  businessUnitName
) {
  const Beds = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/ProgramUnitBedAppointments/${soarOrg}/${businessUnitName}/${programUnitId}/${admissionDate}`
  );

  return ArrayCheck(JSON.parse(Beds).resultset.result);
}

export async function getServiceItems(signal) {
  try {
    const serviceItems = await eurekaGet(
      `https://eurekaapi.azurewebsites.net/Get/ServiceItems/${soarOrg}`,
      signal
    );

    return ArrayCheck(JSON.parse(serviceItems).resultset.result);
  } catch (err) {
    return "error: " + err;
  }
}

export async function getCounties(signal) {
  const counties = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/Counties/${soarOrg}`,
    signal
  );

  if (!signal?.aborted) {
    return ArrayCheck(JSON.parse(counties).resultset.result);
  }
}

export async function getDischargedClientsForProgramUnit(programUnit) {
  const clients = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/ProgramUnit/Discharged/${soarOrg}/${programUnit}`
  );

  return ArrayCheck(JSON.parse(clients).resultset.result);
}

export async function getProgramsByState(state, discharged) {
  const programs = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/ClientProgram/${
      discharged ? "Discharged" : "Active"
    }/${soarOrg}/${state}`
  );

  return ArrayCheck(JSON.parse(programs).resultset.result);
}

export async function getBedDayStatuses(fosterHomeBedId, signal) {
  const statuses = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/BedDays/ByBed/${soarOrg}/${fosterHomeBedId}`,
    signal
  );

  if (!signal?.aborted) {
    return ArrayCheck(JSON.parse(statuses).resultset.result);
  }
}

export async function getBDSForBedAppointment(bedAppointmentId, signal) {
  const statuses = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/BedDays/ByBedAppointment/${soarOrg}/${bedAppointmentId}`,
    signal
  );

  if (!signal?.aborted) {
    return ArrayCheck(JSON.parse(statuses).resultset.result);
  }
}

export async function getFosterParentAccounts(signal) {
  try {
    const accounts = await eurekaGet(
      `${reactApiUrl}/Get/FosterParents/${soarOrg}`,
      signal
    );

    return ArrayCheck(JSON.parse(accounts).resultset.result);
  } catch (err) {
    return "error: " + err;
  }
}

export async function proxyCall(url) {
  console.log("proxyCall", url);
  const result = await callProxyApi(url);

  return result;
}

// export async function updateSoarRecord(entityName, id, domainName, obj) {
//   const update = await soarUpdateApi(
//     `SOARU?entityName=${entityName}&id=${id}&obj=${encodeURIComponent(obj)}`,
//     domainName
//   );

//   return update;
// }

// export async function updateSoarRecord2(entityName, id, domainName, obj) {
//   const update = await soarUpdateApi(
//     `SOAR/Post/${orgApi}/${domainName}/${entityName}/${id}`,
//     obj,
//     1
//   );

//   return update;
// }

export async function postSoarRecord(entityName, id, domainName, obj) {
  const postResult = await soarPostApi(
    `SOAR/Post/${orgApi}/${domainName.replace(
      "safy\\",
      ""
    )}/${entityName}/${id}`,
    JSON.stringify(obj), //had to stringify here because didnt want to edit DischargeChecklistModal yet
    1
  );

  return postResult;
}

// export async function createSoarRecord2(entityName, domainName, obj) {
//   return new Promise((resolve, reject) => {
//     soarUpdateApi(
//       `SOAR/CREATE/${orgApi}/${domainName}/${entityName}`,
//       encodeURIComponent(obj),
//       1
//     )
//       .then(resolve)
//       .catch(reject);
//   });
// }

//EUREKA API
async function eurekaGet(uri, signal) {
  try {
    if (msalInstance.getActiveAccount() !== null) {
      var accessToken = await msalInstance.acquireTokenSilent({
        scopes: ["https://eurekaapi.azurewebsites.net/access_as_user"],
      });

      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${accessToken.accessToken}`);

      var requestOptions = {
        method: "GET",
        headers: myHeaders,
        signal: signal,
      };

      var data = await fetch(uri, requestOptions)
        .then(function (response) {
          return response.json();
        })
        .then(function (result) {
          return result;
        });

      return data;
    }
    return null;
  } catch (err) {
    return "error:" + err;
  }
}

async function zGet(uri, signal) {
  try {
    if (msalInstance.getActiveAccount() !== null) {
      var accessToken = await msalInstance.acquireTokenSilent({
        scopes: ["api://cac763ca-9513-4d8a-82ca-52ae1332a1fb/access_as_user"],
      });

      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${accessToken.accessToken}`);

      var requestOptions = {
        method: "GET",
        headers: myHeaders,
        signal: signal,
      };

      var data = await fetch(uri, requestOptions)
        .then(function (response) {
          return response.json();
        })
        .then(function (result) {
          if (result.data[0]?.code === "fail") {
            console.log("FAIL", result.data[0]);
          }
          return result;
        });

      return data;
    }
    return null;
  } catch (err) {
    return "error:" + err;
  }
}

function zPost(uri, body, signal) {
  return new Promise(async (resolve, reject) => {
    try {
      var accessToken = await acquireAccessToken(msalInstance);
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${accessToken.accessToken}`);
      var requestOptions = {
        method: "POST",
        body: JSON.stringify(body),
        headers: myHeaders,
        signal: signal,
      };
      var data = await fetch(uri, requestOptions)
        .then(function (response) {
          return response.json();
        })
        .then(function (result) {
          if (result.data && result.data[0]?.code === "fail")
            reject(result.data[0]);
          else resolve(result);
        })
        .catch(reject);
      return data;
    } catch (err) {
      reject(err);
    }
  });
}

function eurekaPost(uri, body) {
  return new Promise(async (resolve, reject) => {
    var accessToken = await msalInstance
      .acquireTokenSilent({
        scopes: ["https://eurekaapi.azurewebsites.net/access_as_user"],
      })
      .catch(reject);

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${accessToken.accessToken}`);

    var requestOptions = {
      method: "POST",
      body: JSON.stringify(body),
      headers: myHeaders,
    };

    var data = await fetch(uri, requestOptions)
      .then(function (response) {
        return response.json();
      })
      .then(function (result) {
        const resultJSON =
          result.constructor === Object ? result : JSON.parse(result);

        if (
          resultJSON &&
          resultJSON.SystemResponse &&
          resultJSON.SystemResponse[0] &&
          resultJSON.SystemResponse[0].Code === "FAIL"
        )
          reject(result);
        else resolve(result);
      })
      .catch(reject);

    return data;
  });
}

async function zetoGet(uri, signal) {
  if (msalInstance.getActiveAccount() !== null) {
    var accessToken = await msalInstance.acquireTokenSilent({
      scopes: ["https://eurekaapi.azurewebsites.net/access_as_user"],
    });

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${accessToken.accessToken}`);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      signal: signal,
    };

    var response = await fetch(uri, requestOptions);
    var result = await response.json();
    return result;
  } else {
    const err = new Error("Unauthorized");
    err.name = "Unauthorized";
    throw err;
  }
}

async function zetoPost(uri, body) {
  if (msalInstance.getActiveAccount() !== null) {
    var accessToken = await msalInstance.acquireTokenSilent({
      scopes: ["https://eurekaapi.azurewebsites.net/access_as_user"],
    });

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${accessToken.accessToken}`);

    var requestOptions = {
      method: "POST",
      body: JSON.stringify(body),
      headers: myHeaders,
    };

    var response = await fetch(uri, requestOptions);
    var result = await response.json();
    const failures = result?.SystemResponse?.filter(
      (response) => response.Code === "FAIL"
    );

    // result or SystemResponse could lead to a value of undefined
    if (failures === undefined) {
      // catastrophic failure, result or result.SystemResponse is undefined
      const err = new Error("Undefined Result");
      err.name = "UndefinedResult";
      throw err;
    } else if (failures.length > 0) {
      const err = new Error("One or more records failed to post", {
        cause: {
          requestURI: uri,
          requestBody: body,
          result: result,
          failures: failures,
        },
      });
      err.name = "PostError";
      throw err;
    }

    return result;
  } else {
    const err = new Error("Unauthorized");
    err.name = "Unauthorized";
    throw err;
  }
}

// async function eurekaPostNoJson(uri, body) {
//   try {
//     var accessToken = await msalInstance.acquireTokenSilent({
//       scopes: ["https://eurekaapi.azurewebsites.net/access_as_user"],
//     });

//     var myHeaders = new Headers();
//     myHeaders.append("Content-Type", "text/plain");
//     myHeaders.append("Authorization", `Bearer ${accessToken.accessToken}`);

//     var requestOptions = {
//       method: "POST",
//       body: body,
//       headers: myHeaders,
//     };

//     var data = await fetch(uri, requestOptions)
//       .then(function (response) {
//         const responseText = response.text();
//         return responseText;
//       })
//       .then(function (result) {
//         const resultJSON = JSON.parse(result);
//         return resultJSON.resultset.result;
//       });

//     return data;
//   } catch (err) {
//     return "error:" + err;
//   }
// }

export async function reactDBWhoAmI(userName, azureId) {
  try {
    return eurekaGet(
      `https://eurekaapi.azurewebsites.net/Get/WhoAmI3/${databaseOrg}/${soarOrg}/${azureId}/${userName}`
    );
  } catch (err) {
    return "error: " + err;
  }
}

export async function getFormContainersAndVersions() {
  try {
    return eurekaGet(
      `https://eurekaapi.azurewebsites.net/Formsy/Version/Setup/${databaseOrg}`
    );
  } catch (err) {
    return "error: " + err;
  }
}

export async function saveFormsySubmission(submission, command) {
  //THIS IS FOR FORMSY V2 AND BEYOND
  try {
    return eurekaPost(
      `https://eurekaapi.azurewebsites.net/Formsy/V2/Submission/Upsert/${command}`,
      submission
    );
  } catch (err) {
    return "error: " + err;
  }
}

export async function saveFormsyRelatedObject(id, relatedJSON) {
  console.log("saveFormsyRelatedObject", id, relatedJSON);
  //seems to be erroring here
  const safyUser = JSON.parse(localStorage.getItem("safyInfo")).user;
  try {
    const obj = {
      SubmissionId: id,
      ModifiedById: safyUser.azureId.toUpperCase(),
      ModifiedByName: safyUser.displayName,
      Related: relatedJSON,
    };
    console.log("saveFormsyRelatedObject Object", obj);
    return eurekaPost(
      `https://eurekaapi.azurewebsites.net/Formsy/v2/Submission/RelatedObjects/Upsert`,
      obj
    );
  } catch (err) {
    return `error: ${err}`;
  }
}

export async function getFormsySubmissionsByIds(
  formVersionId,
  contactId,
  signal
) {
  try {
    return eurekaGet(
      `https://eurekaapi.azurewebsites.net/Formsy/Get/Form/Client/Submissions/${databaseOrg}/${formVersionId}/${contactId}`,
      signal
    );
  } catch (err) {
    return "error:" + err;
  }
}

export async function getFormsySubmissionForClient(contactId) {
  try {
    // return eurekaGet(
    //   `https://eurekaapi.azurewebsites.net/Formsy/Get/Client/Submissions/${databaseOrg}/${contactId}`
    // );
    return eurekaGet(
      `https://eurekaapi.azurewebsites.net/Formsy/Get/Client/Submissions/List/${databaseOrg}/${contactId}`
    );
  } catch (err) {
    return "error:" + err;
  }
}

export async function getFormsySubmissionsForMultiple(contactArray) {
  try {
    const response = await eurekaPost(
      `https://eurekaapi.azurewebsites.net/Formsy/Get/Client/Submissions/List/${databaseOrg}`,
      contactArray
    );
    const history = JSON.parse(response).Submissions.Submission || [];
    const sortedHistory = history.sort((a, b) => {
      const aDate = new Date(a.CreatedOn);
      const bDate = new Date(b.CreatedOn);
      if (aDate < bDate) return -1;
      if (aDate > bDate) return 1;
      return 0;
    });
    return sortedHistory;
  } catch (err) {
    return "error:" + err;
  }
}

export async function getFormsySubmission(submissionId) {
  try {
    return eurekaGet(
      `https://eurekaapi.azurewebsites.net/Formsy/Get/Submission/${databaseOrg}/${submissionId}`
    );
  } catch (err) {
    return "error:" + err;
  }
}

export async function getFormsySubmissionsV2(submissionId) {
  try {
    return eurekaGet(
      `https://eurekaapi.azurewebsites.net/Formsy/v2/Get/Submission/${submissionId}`
    );
  } catch (err) {
    return "error:" + err;
  }
}

export async function getFormsySubmissionsBySubmissionIds(submissionIds) {
  try {
    const obj = {
      Submissions: submissionIds,
    };
    return eurekaPost(
      `https://eurekaapi.azurewebsites.net/Formsy/MobileCrisis/Submissions/${databaseOrg}`,
      obj
    );
  } catch (err) {
    return `error: ${err}`;
  }
}

export async function getRelatedFormsySubmissions(containers, relatedId) {
  console.log("containers", containers, "related", relatedId);
  try {
    const obj = {
      Containers: containers,
      ObjectIdentifier: relatedId,
    };
    return eurekaPost(
      `https://eurekaapi.azurewebsites.net/Formsy/V2/Container/Submissions`,
      obj
    );
  } catch (err) {
    return "error: " + err;
  }
}

export async function getFormsyConfig(formVersionId) {
  try {
    return eurekaGet(
      `https://eurekaapi.azurewebsites.net/Formsy/Configuration/${databaseOrg}/${formVersionId}`
    );
  } catch (err) {
    return "error:" + err;
  }
}

export async function getFormsySubmissionsByFormIdForClient(
  formId,
  contactId,
  signal
) {
  try {
    return eurekaGet(
      `https://eurekaapi.azurewebsites.net/Formsy/Get/Form/Client/Submissions/AllVersions/${databaseOrg}/${formId}/${contactId}`,
      signal
    );
  } catch (err) {
    if (err.name !== "AbortError") {
      return err;
    }
  }
}

export async function getFormsySubmissionsByFormId(formContainerId) {
  try {
    const submissionResults = await eurekaGet(
      `${reactApiUrl}/Formsy/Get/Form/Submissions/AllVersions/${databaseOrg}/${formContainerId}`
    );

    return ArrayCheck(JSON.parse(submissionResults).FormSubmissions.Submission);
  } catch (err) {
    return "error:" + err;
  }
}

export async function getFormsySubmissionsReport(
  formContainerId,
  programUnitName,
  beginDate,
  endDate,
  signal
) {
  try {
    const submissionResults = await eurekaGet(
      `${reactApiUrl}/Formsy/Get/Submissions/Reporting/List/${databaseOrg}/${formContainerId}/${programUnitName}/${beginDate}/${endDate}`,
      signal
    );

    return ArrayCheck(JSON.parse(submissionResults).Submissions.Submission);
  } catch (err) {
    return "error: " + err;
  }
}

export async function getFormsyUnsignedSubmissionsByProgramUnit(programUnit) {
  try {
    return eurekaGet(
      `https://eurekaapi.azurewebsites.net/Formsy/Get/Program/Submissions/NotFinalSigned/${databaseOrg}/${programUnit}`
    );
  } catch (err) {
    return "error: " + err;
  }
}

export async function getFormsyReportContactsList(
  formId,
  programName,
  fieldNames,
  fieldValues
) {
  let searchEquation = "between";

  // if (fieldNames.length === 2) searchEquation = "equal";

  const body = {
    FormId: formId,
    ProgramName: programName,
    ResultsType: "Clients",
    SearchEquation: searchEquation,
    SearchFields: fieldNames.map((field) => {
      return { FieldName: field };
    }),
    SearchValues: fieldValues.map((value) => {
      return { FieldValue: value };
    }),
  };

  const contactResults = await eurekaPost(
    `https://eurekaapi.azurewebsites.net/Formsy/Reports/ListBuilder/${databaseOrg}`,
    body
  );

  return ArrayCheck(JSON.parse(contactResults).clients.client);
}

export async function getFormsyReportSubmissionsList(
  formId,
  programName,
  fieldNames,
  fieldValues,
  clientList
) {
  let searchEquation = "between";

  // if (fieldNames.length === 2) searchEquation = "equal";

  const body = {
    FormId: formId,
    ProgramName: programName,
    SearchEquation: searchEquation,
    SearchFields: fieldNames.map((field) => {
      return { FieldName: field };
    }),
    SearchValues: fieldValues.map((value) => {
      return { FieldValue: value };
    }),
    ClientList: clientList.map((client) => {
      return { ContactId: client.toUpperCase() };
    }),
  };

  const submissionResults = await eurekaPost(
    `https://eurekaapi.azurewebsites.net/Formsy/Reports/ReportBuilder/${databaseOrg}`,
    body
  );

  return ArrayCheck(JSON.parse(submissionResults).FormSubmissions.Submission);
}

export async function getFormContainers() {
  try {
    return eurekaGet(
      `https://eurekaapi.azurewebsites.net/Formsy/Get/Container/List/${databaseOrg}`
    );
  } catch (err) {
    return "error: " + err;
  }
}

export function getQualoContact(twistId, signal) {
  return zGet(`${zetoApiUrl}/Qualo/Client/Data/${twistId}`, signal);
}

export async function getCurrentlyOnCall() {
  try {
    return eurekaGet(
      "https://eurekaapi.azurewebsites.net/get/currentlyoncall/oncall"
    );
  } catch (err) {
    return "error: " + err;
  }
}

export async function getCurrentlyOnCallv2() {
  try {
    return eurekaGet(
      `https://eurekaapi.azurewebsites.net/get/currentlyoncall/v2/oncall/`
    );
  } catch (err) {
    return "error: " + err;
  }
}

export async function getHistoricalOnCall(location, backTo) {
  try {
    return eurekaGet(
      `https://eurekaapi.azurewebsites.net/Get/OnCallLocationHistory/OnCall/${location}/${backTo}`
    );
  } catch (err) {
    return "error: " + err;
  }
}

export async function getAvailableEmployees(division) {
  return new Promise((resolve, reject) => {
    try {
      eurekaGet(
        `https://eurekaapi.azurewebsites.net/Get/OnCall/AvailableEmployees/warehouse/${division}`
      )
        .then(resolve)
        .catch(reject);
    } catch (err) {
      reject("error: " + err);
    }
  });
}

export async function getAvailableEmployeesByState(state) {
  return new Promise((resolve, reject) => {
    try {
      eurekaGet(
        `https://eurekaapi.azurewebsites.net/Get/OnCall/AvailableEmployees/StateLevel/warehouse/${state}`
      )
        .then(resolve)
        .catch(reject);
    } catch (err) {
      reject("error: " + err);
    }
  });
}

export async function getAvailableExecutives(signal) {
  try {
    return eurekaGet(
      `https://eurekaapi.azurewebsites.net/Get/OnCall/AvailableExecutives`,
      signal
    );
  } catch (err) {
    if (err.name !== "AbortError") {
      return err;
    }
  }
}

export async function saveOnCallAssignment(callLog) {
  return eurekaPost(
    "https://eurekaapi.azurewebsites.net/Upsert/OnCallLog/OnCall/",
    callLog
  );
}

export async function saveInPersonOnCall(receiver) {
  return eurekaPost(
    "https://eurekaapi.azurewebsites.net/Upsert/InPersonLog/OnCall/",
    receiver
  );
}

export async function saveInPersonOnCallv2(receiver) {
  return eurekaPost(
    "https://eurekaapi.azurewebsites.net/Upsert/InPersonLog//v2/OnCall",
    receiver
  );
}

export async function saveExecutiveOnCall(data) {
  return eurekaPost(
    "https://eurekaapi.azurewebsites.net/Upsert/ExecutiveOnCallLog/OnCall",
    data
  );
}

export async function sendEmail(to, replyTo, subject, body, cc) {
  return new Promise((resolve, reject) => {
    try {
      const messageBody = {
        MailTo: ArrayCheck(to),
        MailCC: ArrayCheck(cc),
        MailReplyTo: replyTo,
        MailSubject: subject,
        MailBody: body,
      };
      eurekaPost(
        `https://eurekaapi.azurewebsites.net/System/Mail/${
          cc === undefined ? "Auto" : "wCC"
        }`,
        messageBody
      )
        .then(resolve)
        .catch(reject);
    } catch (err) {
      reject("error: " + err);
    }
  });
}

export async function sendEmailMessage(
  to,
  replyTo,
  subject,
  body,
  cc,
  attachments,
  highPriority,
  bcc
) {
  return new Promise((resolve, reject) => {
    try {
      const messageBody = {
        MailTo: ArrayCheck(to),
        MailReplyTo: ArrayCheck(replyTo),
        MailCC: ArrayCheck(cc),
        MailBCC: ArrayCheck(bcc),
        MailSubject: subject,
        HighPriority: highPriority,
        MailBody: body,
        MailAttachment: ArrayCheck(attachments),
      };
      eurekaPost(
        `https://eurekaapi.azurewebsites.net/System/Mail/Message`,
        messageBody
      )
        .then(resolve)
        .catch(reject);
    } catch (err) {
      reject("error: " + err);
    }
  });
}

export async function writeLoggedIn(
  username,
  displayName,
  azureAdId,
  company,
  siteUrl,
  details
) {
  const logBody = {
    Username: username,
    DisplayName: displayName,
    AzureAdId: azureAdId,
    Company: company,
    SiteUrl: siteUrl,
    Details: details,
  };

  return eurekaPost(
    "https://eurekaapi.azurewebsites.net/System/Log/Login/Detail",
    logBody
  );
}

export async function getLoggedInHistory(site, beginDate, endDate) {
  return eurekaGet(
    `https://eurekaapi.azurewebsites.net/Reports/Portal/Logins/PortalLog/${site}/${beginDate}/${endDate}`
  ).then((result) => {
    if (result !== "<History></History>") return JSON.parse(result);
    return null;
  });
}

export async function saveReferral(referral, site, command) {
  return eurekaPost(
    `https://eurekaapi.azurewebsites.net/Component/Upsert/Referral/${site}/${command}`,
    referral
  );
}

export async function getReferrals(site, signal) {
  return eurekaGet(
    `https://eurekaapi.azurewebsites.net/Component/Get/Referrals/${site}`,
    signal
  );
}

export async function getReferral(referralId) {
  return eurekaGet(
    `https://eurekaapi.azurewebsites.net/Component/Get/Referral/${databaseOrg}/${referralId}`
  );
}

export async function getReferralsByClient(clientId) {
  return new Promise((resolve, reject) => {
    try {
      eurekaGet(
        `https://eurekaapi.azurewebsites.net/Component/Get/Referrals/Client/${databaseOrg}/${clientId}`
      )
        .then((result) => {
          const resultJSON = JSON.parse(result);

          if (resultJSON && resultJSON.Referrals)
            resolve(ArrayCheck(resultJSON.Referrals.Referral));
          else resolve([]);
        })
        .catch(reject);
    } catch (error) {
      reject(error);
    }
  });
}

export async function getSOARClients(company, connection) {
  return eurekaGet(
    `https://eurekaapi.azurewebsites.net/GetSOARClients/Company/${connection}/${company}`
  );
}

export async function getUnsignedWorkerEncounters(userId, company) {
  return eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/Encounter/Worker/${soarOrg}/${company}/${userId}`
  );
}

export async function getUnsignedProgramEncounters(programId) {
  const encounters = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/Encounter/ProgramUnit/NotDraftSigned/${soarOrg}/${programId}`
  );

  return ArrayCheck(JSON.parse(encounters).resultset.result);
}

export async function getSupervisionLogs() {
  try {
    return eurekaGet(
      `https://eurekaapi.azurewebsites.net/Component/Get/SupervisorLogs/${databaseOrg}`
    );
  } catch (err) {
    return "error: " + err;
  }
}
export async function getSupervisionLog(logId) {
  try {
    return eurekaGet(
      `https://eurekaapi.azurewebsites.net/Component/Get/SupervisorLog/${databaseOrg}/${logId}`
    );
  } catch (err) {
    return "error: " + err;
  }
}

export async function saveSupervisionLog(supervisionlog, command) {
  return eurekaPost(
    `https://eurekaapi.azurewebsites.net/Component/Upsert/SupervisorLog/${databaseOrg}/${command}/`,
    supervisionlog
  );
}

//Group Supervision Logs
export async function getGroupSupervisionLogs(userId) {
  try {
    const logs = await eurekaGet(
      `https://eurekaapi.azurewebsites.net/Component/Get/SupervisionLogs/Group/${databaseOrg}/${userId}`
    );
    return JSON.parse(logs).SupervisorLogs.SupervisorLog.sort((a, b) => {
      const aDate = new Date(a.DateCompleted);
      const bDate = new Date(b.DateCompleted);
      if (aDate < bDate) return 1;
      if (aDate > bDate) return -1;
      return 0;
    });
  } catch (err) {
    return "error: " + err;
  }
}
export async function getGroupSupervisionLog(logId) {
  try {
    return eurekaGet(
      `https://eurekaapi.azurewebsites.net/Component/Get/SupervisionLog/Group/${databaseOrg}/${logId}`
    );
  } catch (err) {
    return "error: " + err;
  }
}

export async function saveGroupSupervisionLog(supervisionlog, command) {
  return eurekaPost(
    `https://eurekaapi.azurewebsites.net/Component/Upsert/SupervisionLog/Group/${databaseOrg}/${command}/`,
    supervisionlog
  );
}

//Individual Supervision Logs
export async function getIndividualSupervisionLogs(userId) {
  try {
    const logs = await eurekaGet(
      `https://eurekaapi.azurewebsites.net/Component/Get/SupervisionLogs/Individual/${databaseOrg}/${userId}`
    );

    return JSON.parse(logs).SupervisorLogs.SupervisorLog.sort((a, b) => {
      const aDate = new Date(a.DateCompleted);
      const bDate = new Date(b.DateCompleted);
      if (aDate < bDate) return 1;
      if (aDate > bDate) return -1;
      return 0;
    });
  } catch (err) {
    return "error: " + err;
  }
}
export async function getIndividualSupervisionLog(logId) {
  try {
    return eurekaGet(
      `https://eurekaapi.azurewebsites.net/Component/Get/SupervisionLog/Individual/${databaseOrg}/${logId}`
    );
  } catch (err) {
    return "error: " + err;
  }
}

export async function saveIndividualSupervisionLog(supervisionlog, command) {
  return eurekaPost(
    `https://eurekaapi.azurewebsites.net/Component/Upsert/SupervisionLog/Individual/2/${databaseOrg}/${command}/`,
    supervisionlog
  );
}

export async function getOpeekaDetails(contactId) {
  return null;
}

export async function getFastTimeEntriesBetweenDates(
  programUnitName,
  startDate,
  endDate,
  signal
) {
  const result = await zetoGet(
    `${reactApiUrl}/Get/FastTimeEntry/ProgramUnit/Eureka/${eurekaEnvironment}/${programUnitName}/${startDate}/${endDate}`,
    signal
  );

  return ArrayCheck(result.data);
}

export async function getEntityMetadata(entityName) {
  try {
    const metadata = await eurekaGet(
      `${reactApiUrl}/Get/Lookup/${soarOrg}/${entityName}`
    );

    return JSON.parse(metadata).entity[0];
  } catch (err) {
    return { Error: err };
  }
}

export async function getFieldMetadata(entityName, fieldName) {
  try {
    const metadata = await eurekaGet(
      `${reactApiUrl}/Get/Lookup/${soarOrg}/${entityName}/${fieldName}`
    );

    return JSON.parse(metadata).entity[0];
  } catch (err) {
    return { Error: err };
  }
}

export async function writeProcessLog(logData) {
  return eurekaPost(
    "https://eurekaapi.azurewebsites.net/System/Log/Process/",
    logData
  );
}

export async function writeShareLog(logData) {
  return eurekaPost(
    "https://eurekaapi.azurewebsites.net/System/Log/Shared/Process/",
    logData
  );
}

export async function writeErrorLog(logData) {
  const browserDetails = await jscd();

  return eurekaPost(
    "https://eurekaapi.azurewebsites.net/System/Log/Error/Details/",
    {
      ...logData,
      EnvironmentDetails: JSON.stringify({
        "OS": `${browserDetails.os} ${browserDetails.osVersion}`,
        "Build": process.env.REACT_APP_BUILD,
        "Browser": `${browserDetails.browser} ${browserDetails.browserMajorVersion} (${browserDetails.browserVersion})`,
        "Mobile": browserDetails.mobile,
        "Cookies": browserDetails.cookies,
        "Screen Size": browserDetails.screen,
        "Full User Agent: ": window.navigator.userAgent,
      }),
    }
  );
}

export async function getProcessLogs(logType, objectReferenceId) {
  const response = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/System/Log/Process/${logType}/${
      process.env.REACT_APP_ENVIRONMENT === "Production"
        ? "ReactLive"
        : "ReactDev"
    }/${objectReferenceId}`
  );

  return ArrayCheck(JSON.parse(response).logs);
}

export async function getErrorLogs(connection, beginDate, endDate) {
  return eurekaGet(
    `https://eurekaapi.azurewebsites.net/Reports/Portal/Logs/Error/PortalLog/${connection}/${beginDate}/${endDate}`
  );
}

export async function getDocusignTransactions(clientId) {
  const transactions = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Reports/Portal/Logs/Docusign/PortalLog/${clientId}/${soarOrg}`
  );
  return JSON.parse(transactions).Docusign.Log.sort((a, b) => {
    const aDate = new Date(a.createdDateTime);
    const bDate = new Date(b.createdDateTime);
    if (aDate < bDate) return 1;
    if (aDate > bDate) return -1;
    return 0;
  });
}

export async function getFormComments(clientId) {
  const comments = await eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/Comments/Eureka/${clientId}`
  );
  return comments;
}

export async function saveFormComment(comment) {
  return eurekaPost(
    `https://eurekaapi.azurewebsites.net/Post/Comment/Eureka`,
    comment
  );
}

export async function deactivateFormComment(commentId) {
  const body = {
    command: "deactivate",
    commentid: commentId,
  };
  return eurekaPost(
    `https://eurekaapi.azurewebsites.net/Post/Comment/Eureka`,
    body
  );
}

export async function postAttachments(attachments) {
  return eurekaPost(
    `https://eurekaapi.azurewebsites.net/Post/Object/Files/Eureka`,
    attachments
  );
}

export async function getAttachments(objectId) {
  return eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/Object/Files/Eureka/${objectId}`
  );
}

export async function getDocusignPDF(envelopeId) {
  return eurekaGet(
    `https://eurekaapi.azurewebsites.net/Reports/Portal/Logs/Docusign/Documents/PortalLog/${envelopeId}`
  );
}

export async function voidDocusignTransaction(body) {
  const uri = "https://safyblueapi.azurewebsites.net/Docusign/Submission/v1_2";

  try {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "POST",
      body: JSON.stringify(body),
      headers: myHeaders,
    };

    var data = await fetch(uri, requestOptions).then(function (response) {
      return response.json();
    });

    return data;
  } catch (err) {
    return "error:" + err;
  }
}

export async function getPDFBytes(carePlanId) {
  return eurekaGet(
    `https://eurekaapi.azurewebsites.net/Component/Get/CarePlan/Base64/${soarOrg}/${carePlanId}`
  );
}

export async function getCallLogs(location) {
  return eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/OnCall/Report/Parent/OnCall/${location}`
  );
}

export async function getCallDetails(callId) {
  return eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/OnCall/Report/Specific/OnCall/${callId}`
  );
}

export async function getCallerInfo(phoneNumber) {
  return eurekaGet(
    `https://eurekaapi.azurewebsites.net/Get/OnCall/Phone/Lookup/SOARLive/${phoneNumber}`
  );
}

export async function getBintiHomes(state) {
  if (state) {
    return eurekaGet(
      `https://eurekaapi.azurewebsites.net/Binti/Get/Homes/BintiDB/${state
        .replaceAll("SAFY of", "")
        .replaceAll(" ", "")}`
    );
  } else {
    return eurekaGet(
      `https://eurekaapi.azurewebsites.net/Binti/Get/Homes/BintiDB`
    );
  }
}

export async function getBintiHomesByStatus(state, status) {
  return eurekaGet(
    `https://eurekaapi.azurewebsites.net/Binti/Homes/v3/Binti/BintiDB/${state}/${status}`
      .replaceAll("SAFY of", "")
      .replaceAll(" ", "")
  );
}

export async function getBintiApplications(state) {
  if (state) {
    return eurekaGet(
      `https://eurekaapi.azurewebsites.net/Binti/Get/Applications/BintiDB/${state
        .replaceAll("SAFY of", "")
        .replaceAll(" ", "")}`
    );
  } else {
    return eurekaGet(
      `https://eurekaapi.azurewebsites.net/Binti/Get/Applications/BintiDB`
    );
  }
}

export async function getBintiApplicationsByStatus(state, status) {
  return eurekaGet(
    `https://eurekaapi.azurewebsites.net/Binti/Get/Applications/BintiDB/${state
      .replaceAll("SAFY of", "")
      .replaceAll(" ", "")}/${status}`
  );
}

export async function getBintiApplicationsByID(id) {
  return eurekaGet(
    `https://eurekaapi.azurewebsites.net/Binti/Get/Applications/BintiDB/${id}`
  );
}

export async function searchBintiFosterHome(field, value) {
  try {
    return eurekaGet(
      `https://eurekaapi.azurewebsites.net/Binti/Get/Family/BintiLive/${field}/${value}`
    );
  } catch (err) {
    return "error:" + err;
  }
}

export async function searchSOARFosterHome(field, value) {
  try {
    return eurekaGet(
      `https://eurekaapi.azurewebsites.net/Binti/Internal/Get/Family/${soarOrg}/${field}/${value}`
    );
  } catch (err) {
    return "error:" + err;
  }
}

export async function getMergedHomes(state) {
  try {
    return eurekaGet(
      `https://eurekaapi.azurewebsites.net/Binti/Homes/v3/Binti/BintiDB/${state}`
    );
  } catch (err) {
    return "error:" + err;
  }
}

// create function named compareBintiSoarHomes that takes in a state and calls /Binti/Get/Homes/Merged/{state}

export async function compareBintiSoarHomes(state) {
  try {
    return eurekaGet(
      `https://eurekaapi.azurewebsites.net/Binti/Get/Homes/Merged/SOARLive/${state}`
    );
  } catch (err) {
    return "error:" + err;
  }
}

export async function getBintiCaseNotes(state, page, id, includes) {
  try {
    return eurekaGet(
      `https://eurekaapi.azurewebsites.net/Binti/v2/Get/CaseNote/BintiLive/${state}/${page}/${id}/${includes}`
    );
  } catch (err) {
    return "error:" + err;
  }
}

export async function getBintiCaseNotesForUAP(uap) {
  try {
    return eurekaGet(
      `https://eurekaapi.azurewebsites.net/Binti/Get/CaseNotes/BintiDB/${uap}`
    );
  } catch (err) {
    return "error:" + err;
  }
}

export async function postBintiCaseNote(location, body) {
  try {
    return eurekaPost(
      `https://eurekaapi.azurewebsites.net/Binti/CrossPlatform/Post/CaseNote/BintiLive/${location}`,
      body
    );
  } catch (err) {
    return "error:" + err;
  }
}

export async function getAgencyWorkers() {
  try {
    return eurekaGet(
      `https://eurekaapi.azurewebsites.net/Binti/Get/AgencyWorkers/BintiDB`
    );
  } catch (err) {
    return "error:" + err;
  }
}

export async function getAvailableBintiTags(state) {
  try {
    return eurekaGet(
      `https://eurekaapi.azurewebsites.net/Binti/Get/Tags/BintiDB/${state}`
    );
  } catch (err) {
    return "error:" + err;
  }
}

export async function saveBintiTags(state, body) {
  try {
    return eurekaPost(
      `https://eurekaapi.azurewebsites.net/Binti/CrossPlatform/Post/Tags/BintiLive/${state}`,
      body
    );
  } catch (err) {
    return "error:" + err;
  }
}

export async function getBillingPayors() {
  try {
    return eurekaGet(
      `https://eurekaapi.azurewebsites.net/Get/BillingRules/List/Payors/Eureka`
    );
  } catch (err) {
    return "error:" + err;
  }
}

export async function billingRules(body) {
  try {
    return eurekaPost(
      `https://eurekaapi.azurewebsites.net/Post/BillingRules/Census/Eureka`,
      body
    );
  } catch (err) {
    return "error:" + err;
  }
}

export async function getBedDayServices(clientId) {
  try {
    return eurekaGet(
      `https://eurekaapi.azurewebsites.net/Get/Client/RecordedServices/NeedsBed/${soarOrg}/${clientId}`
    );
  } catch (err) {
    return "error:" + err;
  }
}

export async function zetoTest() {
  try {
    return zGet(`https://safyzetoapi.azurewebsites.net/System/WhoAmI`);
  } catch (err) {
    console.log("zetoTest error", err);
    return "error:" + err;
  }
}

export async function getMessagesForUser(soarUserId, signal) {
  const response = await zGet(
    `${zetoApiUrl}/FPReact/Discussion/Outstanding/${soarUserId}`,
    signal
  );
  return response.data;
}

export function saveMessage(message, trigger) {
  return zPost(`${zetoApiUrl}/FPReact/Discussion/Upsert/${trigger}`, message);
}

export async function getWeeklyReport(clientId, beginDate, endDate, signal) {
  const response = await zGet(
    `${zetoApiUrl}/FPReact/Reports/GridWeek/${clientId}/${beginDate}/${endDate}`,
    signal
  );
  return response.data;
}

export async function getClientsByDivisionForApproval(division, signal) {
  const response = await zGet(
    `${zetoApiUrl}/FPApproval/Clients/${division}`,
    signal
  );
  return response.data;
}

export async function getClientsByDivisionForApprovalWithTraining(
  division,
  signal
) {
  const response = await zGet(
    `${zetoApiUrl}/FPApproval/Clients/Test/${division}`,
    signal
  );
  return response.data;
}

export async function getServicesForApprovalByClient(clientId, signal) {
  const response = await zGet(
    `${zetoApiUrl}/FPApproval/Client/Services/${clientId}`,
    signal
  );
  return response.data;
}

export async function getServicesForApprovalByClientWithTraining(
  clientId,
  signal
) {
  const response = await zGet(
    `${zetoApiUrl}/FPApproval/Client/Services/Training/${clientId}`,
    signal
  );
  return response.data;
}

export function revertDraft(recordedServiceId, signal) {
  return zGet(
    `${zetoApiUrl}/FPApproval/Service/Revert/${recordedServiceId}`,
    signal
  );
}

export async function confirmService(service) {
  const response = await zPost(
    `${zetoApiUrl}/FPApproval/Service/Confirm`,
    service
  );
  return response.data[0];
}

export async function confirmServices(services) {
  const response = await zPost(
    `${zetoApiUrl}/FPApproval/Services/Confirm`,
    services
  );
  return response.data[0];
}

export function deactivateService(recordedServiceId, signal) {
  return zGet(
    `${zetoApiUrl}/FPApproval/Service/Deactivate/${recordedServiceId}`,
    signal
  );
}

export async function getServicesForClientsByDates(
  clientId,
  startDate,
  endDate
) {
  const body = {
    ClientIds: [clientId],
    StartDate: startDate,
    EndDate: endDate,
  };
  const response = await zPost(
    `${zetoApiUrl}/FPApproval/Clients/Services/DuplicateCheck`,
    body
  );

  return response.data[0];
}

export async function getCensusPayors() {
  const response = await zPost(`${zetoApiUrl}/Census/Payors`, {
    command: "query",
    keyword: "viewall",
    application:
      process.env.REACT_APP_ENVIRONMENT === "Production"
        ? "5dae139e-d052-4bd8-bf4a-499a31ac3c15"
        : "58990f83-8566-4ba8-b4b5-584a64e4cba1",
  });

  if (response.code === "success") {
    return response.data;
  } else {
    toast.error("Error Getting Payors");
    return [];
  }
}

export async function getCensusPayor(id) {
  const response = await zPost(`${zetoApiUrl}/Census/Payors`, {
    command: "query",
    keyword: "byid",
    ids: [id],
    application:
      process.env.REACT_APP_ENVIRONMENT === "Production"
        ? "5dae139e-d052-4bd8-bf4a-499a31ac3c15"
        : "58990f83-8566-4ba8-b4b5-584a64e4cba1",
  });

  if (response.code === "success") {
    return response.data[0];
  } else {
    toast.error("Error Getting Payors");
    return [];
  }
}

export async function getCensusGroupPlans() {
  const response = await zGet(`${zetoApiUrl}/Census/GroupPlans`);

  return response.data;
}

export async function censusPayorAction(body) {
  const response = await zPost(`${zetoApiUrl}/Census/Payors`, body);

  if (response.code === "success") {
    return response;
  } else {
    toast.error("Error Inserting Payor");
    return [];
  }
}

export async function censusGroupPlanAction(body) {
  const response = await zPost(`${zetoApiUrl}/Census/GroupPlans`, body);
  return response;
}

export async function censusClientPayors(body) {
  const response = await zPost(
    `${zetoApiUrl}/census/client/assignments/payors`,
    body
  );
  return response;
}

export async function censusServices(body) {
  const response = await zPost(`${zetoApiUrl}/Census/Services`, body);

  return response;
}

export async function censusServiceConfigs(body) {
  const response = await zPost(
    `${zetoApiUrl}/census/services/configurations`,
    body
  );

  return response;
}

export async function censusBillingRules(body) {
  const response = await zPost(`${zetoApiUrl}/billing/rules`, body);
  return response;
}

export async function dailyService(body) {
  const response = await zPost(`${zetoApiUrl}/Census/Services/Daily`, body);
  return response;
}

export async function programUnitsModality(body) {
  const response = await zPost(`${zetoApiUrl}/soar/program/modalities`, body);
  return response;
}

export async function getSPDocumentsForId(id, type, state) {
  const body = {
    Command: "query",
    Keyword: "documentsFiltered",
    LibraryId: state,
    Field: type,
    Value: id,
  };
  const resp = await zPost(`${zetoApiUrl}/Graph/Request`, body);

  if (resp?.data) return resp.data;
  else {
    toast.error(`Error fetching documents: ${resp.message}`);
    return null;
  }
}

export async function getSPDocumentLibraries(signal) {
  const body = {
    Command: "query",
    Keyword: "libraries",
  };
  const resp = await zPost(`${zetoApiUrl}/Graph/Request`, body, signal);

  if (resp?.data) return resp.data;
  else {
    toast.error(`Error fetching documents: ${resp.message}`);
    return null;
  }
}

export async function sharePoint(body) {
  const resp = await zPost(`${zetoApiUrl}/Graph/Request`, body);

  return resp;
}

export async function getClinicalResourceLibrary(token) {
  try {
    const body = {
      userToken: token,
    };

    let allItems = [];

    const response = await eurekaPost(
      "https://eurekaapi.azurewebsites.net/System/MSGraph/ClinicalResourceLibrary",
      body
    );
    let items = JSON.parse(response);
    allItems = allItems.concat(items.value);

    if (items["@odata.nextLink"] != null) {
      return fetchAdditionalLinks(
        items["@odata.nextLink"],
        token,
        allItems
      ).then((response2) => response2);
    } else {
      return allItems;
    }
  } catch (err) {
    return "error:" + err;
  }
}

// export async function perDiem(path, body, signal) {
//   try {
//     return zPost(`${zetoApiUrl}/PerDiem/${path}`, body, signal);
//   } catch (err) {
//     return "error:" + err;
//   }
// }

export async function residenceContact(body) {
  try {
    return zPost(`${zetoApiUrl}/Residences/Contacts`, body);
  } catch (err) {
    return "error:" + err;
  }
}

export async function residenceContactAssignment(body) {
  try {
    return zPost(`${zetoApiUrl}/Residences/Assignments/Contacts`, body);
  } catch (err) {
    return "error:" + err;
  }
}

export async function residenceClientAssignment(body) {
  try {
    return zPost(`${zetoApiUrl}/Residences/Assignments/Clients`, body);
  } catch (err) {
    return "error:" + err;
  }
}

export async function residences(body) {
  try {
    return zPost(`${zetoApiUrl}/residences`, body);
  } catch (err) {
    return "error:" + err;
  }
}

export async function residenceLease(body) {
  try {
    return zPost(`${zetoApiUrl}/Residences/Leases`, body);
  } catch (err) {
    return "error:" + err;
  }
}

export async function residenceUtility(body) {
  try {
    return zPost(`${zetoApiUrl}/Residences/Utilities`, body);
  } catch (err) {
    return "error:" + err;
  }
}

export async function residenceRelated(body) {
  try {
    return zPost(`${zetoApiUrl}/Residences/Related`, body);
  } catch (err) {
    return "error:" + err;
  }
}

export async function residenceNotes(body) {
  try {
    return zPost(`${zetoApiUrl}/Residences/Notes`, body);
  } catch (err) {
    return "error:" + err;
  }
}

export async function residenceBeds(body) {
  try {
    return zPost(`${zetoApiUrl}/Residences/Beds`, body);
  } catch (err) {
    return "error:" + err;
  }
}

export async function residenceClientAssginment(body) {
  try {
    return zPost(`${zetoApiUrl}/Residences/Beds/Assignments/Clients`, body);
  } catch (err) {
    return "error: " + err;
  }
}

export async function binti(body) {
  try {
    return zPost(`${zetoApiUrl}/Binti/homes`, body);
  } catch (err) {
    return "error:" + err;
  }
}

export async function SOARResources(body) {
  try {
    return zPost(`${zetoApiUrl}/SOAR/Resources`, body);
  } catch (err) {
    return "error:" + err;
  }
}

export async function clientList(body, signal) {
  try {
    return zPost(`${zetoApiUrl}/SOAR/Clients`, body, signal);
  } catch (err) {
    return "error:" + err;
  }
}

export async function crisisReferrals(body, signal) {
  try {
    return zPost(`${zetoApiUrl}/crisis/referrals`, body, signal);
  } catch (err) {
    return "error:" + err;
  }
}

export async function crisisResponder(body, signal) {
  try {
    return zPost(`${zetoApiUrl}/crisis/referrals/responders`, body, signal);
  } catch (err) {
    return "error" + err;
  }
}

export async function sendSMS(body, signal) {
  try {
    return zPost(`${zetoApiUrl}/system/sms/message`, body, signal);
  } catch (err) {
    return "error" + err;
  }
}

export async function reactManagementUsers(body, signal) {
  try {
    return await zPost(`${zetoApiUrl}/react/assignments/modules`, body, signal);
  } catch (err) {
    return "error" + err;
  }
}

const fetchAdditionalLinks = async (odataNextLink, token, allItems) => {
  const obj = {
    userToken: token,
    nextLink: odataNextLink,
  };

  const response = await eurekaPost(
    "https://eurekaapi.azurewebsites.net/System/MSGraph/NextLink",
    obj
  );
  const items = JSON.parse(response);
  allItems = allItems.concat(items.value);
  if (items["@odata.nextLink"] != null) {
    return fetchAdditionalLinks(items["@odata.nextLink"], token, allItems);
  } else {
    return allItems;
  }
};

export async function html2Pdf(element, printColor = false) {
  // return eurekaPost(
  //   `https://eurekaapi.azurewebsites.net/Component/Post/HTML/Base64`,
  //   element
  // );
  try {
    var accessToken = await msalInstance.acquireTokenSilent({
      scopes: ["https://eurekaapi.azurewebsites.net/access_as_user"],
    });

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${accessToken.accessToken}`);
    // const bodyJson = JSON.stringify({ HTMLContent: element.innerHTML });

    const bodyJson = JSON.stringify({
      HTMLContent: `<div><link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-rbsA2VBKQhggwzxH7pPCaAqO46MgnOM80zW1RWuH61DGLwZJEdK2Kadq2F9CUG65" crossorigin="anonymous" /><style>
            .bg-safy1-1 {
        background-color: rgba(0, 70, 128, 1) !important;
      }
      .bg-safy1-10 {
        background-color: rgba(0, 70, 128, 0.05) !important;
      }
      .bg-safy1-3 {
        background-color: rgba(0, 70, 128, 0.3) !important;
      }
      .bg-safy2-1 {
        background-color: rgba(0, 118, 168, 1) !important;
      }
      .bg-safy2-4 {
        background-color: rgba(0, 118, 168, 0.4) !important;
      }
      .bg-safy2-5 {
        background-color: rgba(0, 118, 168, 0.5) !important;
      }
      .card-safy {
        border: 1px solid black !important;
        box-shadow: 2px 2px 5px grey;
      }
      .card-body-safy {
        background-color: #dddddd !important;
        /* background-color: rgba(0, 70, 128, 0.3) !important; */
      }

      .card-body-safy-2 {
        background-color: rgba(0, 70, 128, 0.3) !important;
      }

      .bg-safy3-1 {
        background-color: rgba(49, 165, 152, 1) !important;
      }

      .bg-safy3-50 {
        background-color: rgba(49, 165, 152, 0.5) !important;
      }

      .text-safy1-1 {
        color: rgba(0, 70, 128, 1) !important;
      }
      .text-safy2-1 {
        color: rgba(0, 118, 168, 1) !important;
      }
      .text-safy3-1 {
        color: rgba(49, 165, 152, 1) !important;
      }

      .bg-mdwarning {
        background-color: #f9e79f !important;
      }

      .floating-toolbox {
        display:none !important
      }

      .scroll-top {
        height: 20px;
        background-color: transparent;
      }

      .floating-save {
        display:none !important
      }

      .floating-comment {
        display:none !important
      }

      .clinicalNarrative {
       display:none !important
      }

      .clinicalNarrative textarea {
        display:none !important
      }

      button {
        display:none !important
      }

      .btn {
        display: none !important;
      }

      div.print-div {
        display: inline !important;
      }

      input,
      textarea {
        border: none !important;
        box-shadow: none !important;
        outline: none !important;
        resize: none !important;
        margin-top: 0 !important;
        margin-bottom: 0 !important;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
      }

      .taDiv {
        display: none !important
      }

      .noarrow {
        overflow: hidden;
      }

      h1 {
        font-size: 24pt;
      }

      h2 {
        font-size: 14pt;
        margin-top: 25px;
      }

      aside h2 {
        font-size: 18pt;
      }

      .fixedBR {
        position: fixed;
        bottom: 100px;
        right: 40px;
        height: 20px;
        z-index: 1000;
        cursor: pointer;
        animation: fadeIn 0.3s;
        transition: opacity 0.4s;
        opacity: 0.75;
      }

      .text-decoration-underline {
        text-decoration: underline !important;
      }

      .lh-12 {
        line-height: 12px !important;
      }

      /* radiobutton aspect */
      .rbutton ~ .not-checked,
      .rbutton ~ .checked {
        position: relative;
        padding-left: 1.95em;
        cursor: pointer;
      }
      .rbutton ~ .not-checked:before,
      .rbutton ~ .checked:before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 1.25em;
        height: 1.25em;
      }

      .rbutton ~ .not-checked:after,
      .rbutton ~ .checked:after {
        position: absolute;
        top: 0.15em;
        left: 0.22em;
        font-size: 1.3em;
        font-weight: bold;
        line-height: 0.8;
        color: #000000;
        transition: all 0.2s;
        font-family: "Lucida Sans Unicode", "Arial Unicode MS", Arial;
      }

      .rbutton ~ .not-checked:after {
        content: '\\25EF\\0020';
        opacity: 1;
      }
      .rbutton ~ .checked:after {
        content: '\\2B59\\0020';
        opacity: 1;
      }
 
      .rbutton ~ .not-checked:disabled:before,
      .rbutton ~ .checked:disabled:before {
        box-shadow: none;
        border-color: #bbb;
        background-color: #ddd;
      }
      .rbutton ~ .checked:disabled:after {
        color: #999;
      }
      .rbutton:disabled {
        color: #aaa;
      }
      .rbutton {
        display: none !important;
      }

      /* checkbox aspect */
      .form-check-input {
        display: none;
      }
      
      .cbox ~ label > .not-checked,
      .cbox ~ label > .checked {
        position: relative;
        padding-left: 1.95em;
        cursor: pointer;
      }
      .cbox ~ label > .not-checked:before,
      .cbox ~ label > .checked:before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 1.25em;
        height: 1.25em;
      }

      .cbox ~ label > .not-checked:after,
      .cbox ~ label > .checked:after {
        position: absolute;
        top: 0.15em;
        left: 0.22em;
        font-size: 1.3em;
        font-weight: bold;
        line-height: 0.8;
        color: #000000;
        transition: all 0.2s;
        font-family: "Lucida Sans Unicode", "Arial Unicode MS", Arial;
      }

      .cbox ~ label > .not-checked:after {
        content: '\\25FB\\0020';
        opacity: 1;
      }

      .cbox ~ label > .checked:after {
        content: '\\1F5F9\\0020';
        opacity: 1;
      }
 
      .cbox ~ label > .not-checked:disabled:before,
      .cbox ~ label > .checked:disabled:before {
        box-shadow: none;
        border-color: #bbb;
        background-color: #ddd;
      }
      .cbox ~ label > .checked:disabled:after {
        color: #999;
      }
      .cbox:disabled {
        color: #aaa;
      }

      </style>${element.innerHTML}</div>`,
      printColor: printColor,
    });

    var requestOptions = {
      method: "POST",
      body: bodyJson,
      headers: myHeaders,
    };

    var data = await fetch(
      `https://eurekaapi.azurewebsites.net/Component/Post/HTML/Base64/Print`,
      requestOptions
    )
      .then(function (response) {
        const responseText = response.json();
        return responseText;
      })
      .then(function (result) {
        const resultJSON = JSON.parse(result);
        return resultJSON.PDFByteData;
      });

    return data;
  } catch (err) {
    return "error:" + err;
  }
}

export async function html2PdfWithStyle(element, style, printColor = false) {
  // return eurekaPost(
  //   `https://eurekaapi.azurewebsites.net/Component/Post/HTML/Base64`,
  //   element
  // );
  try {
    var accessToken = await msalInstance.acquireTokenSilent({
      scopes: ["https://eurekaapi.azurewebsites.net/access_as_user"],
    });

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${accessToken.accessToken}`);
    // const bodyJson = JSON.stringify({ HTMLContent: element.innerHTML });

    const bodyJson = JSON.stringify({
      HTMLContent: `<div><link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-rbsA2VBKQhggwzxH7pPCaAqO46MgnOM80zW1RWuH61DGLwZJEdK2Kadq2F9CUG65" crossorigin="anonymous" /><style>
      ${style}

      .bg-safy1-1 {
        background-color: rgba(0, 70, 128, 1) !important;
      }
      .bg-safy1-10 {
        background-color: rgba(0, 70, 128, 0.05) !important;
      }
      .bg-safy1-3 {
        background-color: rgba(0, 70, 128, 0.3) !important;
      }
      .bg-safy2-1 {
        background-color: rgba(0, 118, 168, 1) !important;
      }
      .bg-safy2-4 {
        background-color: rgba(0, 118, 168, 0.4) !important;
      }
      .bg-safy2-5 {
        background-color: rgba(0, 118, 168, 0.5) !important;
      }
      .card-safy {
        border: 1px solid black !important;
        box-shadow: 2px 2px 5px grey;
      }
      .card-body-safy {
        background-color: #dddddd !important;
        /* background-color: rgba(0, 70, 128, 0.3) !important; */
      }

      .card-body-safy-2 {
        background-color: rgba(0, 70, 128, 0.3) !important;
      }

      .bg-safy3-1 {
        background-color: rgba(49, 165, 152, 1) !important;
      }

      .bg-safy3-50 {
        background-color: rgba(49, 165, 152, 0.5) !important;
      }

      .text-safy1-1 {
        color: rgba(0, 70, 128, 1) !important;
      }
      .text-safy2-1 {
        color: rgba(0, 118, 168, 1) !important;
      }
      .text-safy3-1 {
        color: rgba(49, 165, 152, 1) !important;
      }

      .bg-mdwarning {
        background-color: #f9e79f !important;
      }

      .floating-toolbox {
        display:none !important
      }

      .scroll-top {
        height: 20px;
        background-color: transparent;
      }

      .floating-save {
        display:none !important
      }

      .floating-comment {
        display:none !important
      }

      .clinicalNarrative {
       display:none !important
      }

      .clinicalNarrative textarea {
        display:none !important
      }

      button {
        display:none !important
      }

      .btn {
        display: none !important;
      }

      div.print-div {
        display: inline !important;
      }

      input,
      textarea {
        border: none !important;
        box-shadow: none !important;
        outline: none !important;
        resize: none !important;
        margin-top: 0 !important;
        margin-bottom: 0 !important;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
      }

      .taDiv {
        display: none !important
      }

      .noarrow {
        overflow: hidden;
      }

      h1 {
        font-size: 24pt;
      }

      h2 {
        font-size: 14pt;
        margin-top: 25px;
      }

      aside h2 {
        font-size: 18pt;
      }

      .fixedBR {
        position: fixed;
        bottom: 100px;
        right: 40px;
        height: 20px;
        z-index: 1000;
        cursor: pointer;
        animation: fadeIn 0.3s;
        transition: opacity 0.4s;
        opacity: 0.75;
      }

      .text-decoration-underline {
        text-decoration: underline !important;
      }

      /* radiobutton aspect */
      .rbutton ~ .not-checked,
      .rbutton ~ .checked {
        position: relative;
        padding-left: 1.95em;
        cursor: pointer;
      }
      .rbutton ~ .not-checked:before,
      .rbutton ~ .checked:before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 1.25em;
        height: 1.25em;
      }

      .rbutton ~ .not-checked:after,
      .rbutton ~ .checked:after {
        position: absolute;
        top: 0.15em;
        left: 0.22em;
        font-size: 1.3em;
        font-weight: bold;
        line-height: 0.8;
        color: #000000;
        transition: all 0.2s;
        font-family: "Lucida Sans Unicode", "Arial Unicode MS", Arial;
      }

      .rbutton ~ .not-checked:after {
        content: '\\25EF\\0020';
        opacity: 1;
      }
      .rbutton ~ .checked:after {
        content: '\\2B59\\0020';
        opacity: 1;
      }
 
      .rbutton ~ .not-checked:disabled:before,
      .rbutton ~ .checked:disabled:before {
        box-shadow: none;
        border-color: #bbb;
        background-color: #ddd;
      }
      .rbutton ~ .checked:disabled:after {
        color: #999;
      }
      .rbutton:disabled {
        color: #aaa;
      }
      .rbutton {
        display: none !important;
      }

      /* checkbox aspect */
      .form-check-input {
        display: none;
      }
      
      .cbox ~ label > .not-checked,
      .cbox ~ label > .checked {
        position: relative;
        padding-left: 1.95em;
        cursor: pointer;
      }
      .cbox ~ label > .not-checked:before,
      .cbox ~ label > .checked:before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 1.25em;
        height: 1.25em;
      }

      .cbox ~ label > .not-checked:after,
      .cbox ~ label > .checked:after {
        position: absolute;
        top: 0.15em;
        left: 0.22em;
        font-size: 1.3em;
        font-weight: bold;
        line-height: 0.8;
        color: #000000;
        transition: all 0.2s;
        font-family: "Lucida Sans Unicode", "Arial Unicode MS", Arial;
      }

      .cbox ~ label > .not-checked:after {
        content: '\\25FB\\0020';
        opacity: 1;
      }

      .cbox ~ label > .checked:after {
        content: '\\1F5F9\\0020';
        opacity: 1;
      }
 
      .cbox ~ label > .not-checked:disabled:before,
      .cbox ~ label > .checked:disabled:before {
        box-shadow: none;
        border-color: #bbb;
        background-color: #ddd;
      }
      .cbox ~ label > .checked:disabled:after {
        color: #999;
      }
      .cbox:disabled {
        color: #aaa;
      }
      </style>${element.innerHTML}</div>`,
      PrintColor: printColor,
    });

    var requestOptions = {
      method: "POST",
      body: bodyJson,
      headers: myHeaders,
    };

    var data = await fetch(
      `https://eurekaapi.azurewebsites.net/Component/Post/HTML/Base64/Print`,
      requestOptions
    )
      .then(function (response) {
        const responseText = response.json();
        return responseText;
      })
      .then(function (result) {
        const resultJSON = JSON.parse(result);
        return resultJSON.PDFByteData;
      });

    return data;
  } catch (err) {
    return "error:" + err;
  }
}
